import { Checkbox, Form, Grid, pn, useElementBreakpoints } from "@compass/core";
import { DatePicker, Select, SubmitButton } from "components";
import { StudentServiceFilter as StudentServiceFilterModel, StudentServiceFilterResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ServiceFilter = (props: {
  filter: StudentServiceFilterModel;
  setFilter: (value: StudentServiceFilterModel) => void;
}) => {
  const { breakpointsRef, xSmallFieldBreakpoints, smallFieldBreakpoints } = useElementBreakpoints();
  const [filter, setFilter] = useState<StudentServiceFilterModel>(props.filter);
  const [resource, setResource] = useState<StudentServiceFilterResource>({});
  const properties = resource.properties || [];

  const serviceSubTypes = resource.serviceSubTypes?.filter((x) => x.serviceTypeId === filter.serviceTypeIds?.[0]);

  useEffect(() => {
    ApiService.studentServices.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  useEffect(() => {
    props.setFilter(filter);
  }, [filter.groupByDate]);

  const serviceTypeField = () => {
    const propertyName = pn<StudentServiceFilterModel>("serviceTypeIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.serviceTypes?.find((x) => x.id === filter?.serviceTypeIds?.[0])}
        options={resource.serviceTypes}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) => {
          const updatedFilter = produce(filter, (draft) => {
            draft.serviceTypeIds = value?.id ? [value?.id] : [];
            draft.serviceSubTypeIds = [];
          });

          setFilter(updatedFilter);
          props.setFilter(updatedFilter);
        }}
        size="small"
      />
    );
  };

  const serviceSubTypeField = () => {
    const propertyName = pn<StudentServiceFilterModel>("serviceSubTypeIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={serviceSubTypes?.find((x) => x.id === filter?.serviceSubTypeIds?.[0])}
        options={serviceSubTypes}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) => {
          const updatedFilter = produce(filter, (draft) => {
            draft.serviceSubTypeIds = value?.id ? [value?.id] : [];
          });

          setFilter(updatedFilter);
          props.setFilter(updatedFilter);
        }}
        size="small"
      />
    );
  };

  const dateFromField = () => {
    const propertyName = pn<StudentServiceFilterModel>("dateFrom");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DatePicker
        modelProperty={property}
        value={filter.dateFrom}
        onChange={(value) => {
          setFilter(
            produce((draft) => {
              draft.dateFrom = value;
            })
          );
        }}
        size="small"
      />
    );
  };

  const dateToField = () => {
    const propertyName = pn<StudentServiceFilterModel>("dateTo");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DatePicker
        modelProperty={property}
        value={filter.dateTo}
        onChange={(value) => {
          setFilter(
            produce((draft) => {
              draft.dateTo = value;
            })
          );
        }}
        size="small"
      />
    );
  };

  const groupByDateField = () => {
    const propertyName = pn<StudentServiceFilterModel>("groupByDate");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Checkbox
        label={property?.displayName}
        checked={filter.groupByDate}
        onChange={(e) => {
          setFilter(
            produce((draft) => {
              draft.groupByDate = e.target.checked;
            }));
          
        }
        }
      />
    );
  };

return (
  <Form style={{ width: "100%" }}>
    <Grid ref={breakpointsRef} container spacing="sm" alignItems="center">
      <Grid item xs={smallFieldBreakpoints}>
        {serviceTypeField()}
      </Grid>

      {serviceSubTypes && serviceSubTypes.length > 0 && (
        <Grid item xs={smallFieldBreakpoints}>
          {serviceSubTypeField()}
        </Grid>
      )}
      <Grid item xs={xSmallFieldBreakpoints}>
        {dateFromField()}
      </Grid>

      <Grid item xs={xSmallFieldBreakpoints}>
        {dateToField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {groupByDateField()}
      </Grid>

      {JSON.stringify(filter) !== JSON.stringify(props.filter) && (
        <Grid item alignItems="center">
          <SubmitButton label="Filter" onClick={() => props.setFilter(filter)} />
        </Grid>
      )}
    </Grid>
  </Form>
);
};
